module.exports = __webpack_public_path__ + "static/media/iPhonex.0b220093.png";